import { render, staticRenderFns } from "./banner-animated.vue?vue&type=template&id=84d6142a"
import script from "./banner-animated.vue?vue&type=script&lang=js"
export * from "./banner-animated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports